/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Hero_BadgeInputs */

const en_platform_hero_badge = /** @type {(inputs: Platform_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For coaches`)
};

const pl_platform_hero_badge = /** @type {(inputs: Platform_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla trenerów`)
};

/**
* | output |
* | --- |
* | "For coaches" |
*
* @param {Platform_Hero_BadgeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_hero_badge = /** @type {((inputs?: Platform_Hero_BadgeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Hero_BadgeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_hero_badge(inputs)
	return en_platform_hero_badge(inputs)
});